import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import Form from 'components/Form';
import MiddlePanel from './MiddlePanel';
import HeaderPanel from './HeaderPanel';
import inputs from './form.json';
import { setNewPassword } from 'redux/actions';
import { ErrorOutline } from '@material-ui/icons';
import Alert from 'react-bootstrap/Alert';

const NewPasswordPanel = () => {
    const dispatch = useDispatch();
    const { loading, resetPassword, error } = useSelector((state) => state.sign);

    const handleSaveUserData = (data) => {
        dispatch(
            setNewPassword({
                ...data,
                _token: resetPassword.token,
            }),
        );
    };

    return loading ? (
        <div className="sign__skeleton">
            <Skeleton height="40px" count={5} />
        </div>
    ) : (
            <Form
                className="form-outline sign--form"
                type="login"
                inputs={inputs.newPassword}
                data={[]}
                title="Zmień hasło"
                handleSubmitEv={handleSaveUserData}
                submitTitle="Zmień hasło"
                formHeader={<HeaderPanel>Zmień swoje hasło</HeaderPanel>}
                formContent={`<p>Prosimy, załóż i potwierdź swoje nowe hasło do logowania.</p>`}
                formMiddle={
                    <MiddlePanel>
                        Bezpieczne hasło powinno składać się z minimum 6 znaków i zawierać wielkie i małe litery, cyfry oraz
                        znaki specjalne.
                </MiddlePanel>
                }
                whiteBg
                formMessage={
                    error && (
                        <Alert variant="danger" className="alert__tiny">
                            <ErrorOutline />
                            <p dangerouslySetInnerHTML={{ __html: error.message }} />
                        </Alert>
                    )
                }
            />
        );
};

export default NewPasswordPanel;
